import { logger } from '@/utils/logger';
import type { MaybeRef } from 'vue';

export const translateError = (errorRef: MaybeRef<string | Record<string, string>>) => {
  const error = unref(errorRef);

  if (typeof error === 'string') {
    return error;
  }

  return useNuxtApp().$i18n.t(`validation.${error.name}`, error.messageParams);
};

export const formatErrorLog = (error: any) => {
  if (error?.response?.data?.error_description) {
    return logger.inspect(error.response.data.error_description);
  }

  const { code, message, name, stack, config, response, cause } = error;

  type ErrorFormatted = {
    message: string;
    code: string;
    name: string;
    stack: string;
    request?: {
      method: string;
      url: string;
      headers: string;
      data: Record<string, any>;
    };
    response?: {
      headers: string;
      data: Record<string, any>;
    };
    cause?: Error;
  };

  const errorFormatted: ErrorFormatted = {
    message,
    code,
    name,
    stack,
  };

  if (config) {
    errorFormatted.request = {
      headers: config.headers,
      method: config.method,
      url: config.url,
      data: config.data,
    };

    if (errorFormatted.request.data?.username) {
      errorFormatted.request.data.username = '[redacted]';
    }
    if (errorFormatted.request.data?.password) {
      errorFormatted.request.data.password = '[redacted]';
    }
  }

  if (response) {
    errorFormatted.response = {
      headers: response.headers,
      data: response.data,
    };
  }

  if (cause) {
    errorFormatted.cause = cause;
  }

  return logger.inspect(errorFormatted);
};
